import React from "react";
import VerifyPanCard from "../../organisms/InitialPagesComponents/CoApplicantAuthBridge/VerifyPanCard/VerifyPanCard";

const CoApplicantVerifyPanCardPage = () => {
  return <VerifyPanCard />;
};

export default CoApplicantVerifyPanCardPage;
